<template>
  <div class="patternmaker-patternmaker-view-body">
    <div class="patternmaker-patternmaker-view-model-image">
      <div
        v-show="!previewImageDataIsReady"
        class="patternmaker-patternmaker-view-spinner text-center">
        <base-spinner
          :size="spinnerSize"
          position="initial"
        ></base-spinner>
      </div>
      <img
        :src="previewImageUrl"
        @load="setPreviewImageIsLoading(false)"
        :alt="translations.customPatternMakerTitle"
        v-show="previewImageUrl"
      />
    </div>
    <div class="text-center">
      <div
        :class="[
        'patternmaker-patternmaker-view-instructions',
        { 'patternmaker-patternmaker-view-error': highligthSelectSwatchInstructions }
        ]"
      >{{ translations.customCheckListInstructions }}</div>
    </div>
    <patternmaker-swatches-carousel
      @swatch-selected="selectSwatch"
      :swatches="swatches"
      :current-swatch="currentSwatch"
      :enabled="previewImageDataIsReady"
      :slide-to-selected-item="slideToSelectedItems"
    ></patternmaker-swatches-carousel>
    <div class="text-center">
      <div
        :class="[
        'patternmaker-patternmaker-view-instructions',
        { 'patternmaker-patternmaker-view-error': highligthSelectStickerInstructions }
        ]"
      >{{ translations.customCheckListInstructions2 }}</div>
    </div>
    <patternmaker-sticker-tabs v-if="enableStickerGroups" :tabs="stickerGroups"></patternmaker-sticker-tabs>
    <patternmaker-stickers-carousel
      @sticker-selected="selectSticker"
      :stickers="stickers"
      :current-sticker="currentSticker"
      :enabled="previewImageDataIsReady"
      :slide-to-selected-item="slideToSelectedItems"
    ></patternmaker-stickers-carousel>
    <div class="row patternmaker-patternmaker-view-buttons-wrapper">
      <div class="small-6 large-6 columns">
        <button
          type="button"
          class="button secondary patternmaker-patternmaker-view-cta"
          :disabled="!previewImageDataIsReady"
          @click="closeModalOption('cancel')"
        >{{ translations.customCheckCancel }}</button>
      </div>
      <div class="small-6 large-6 columns">
        <button
          @click="finish()"
          :class="[
            'button primary patternmaker-patternmaker-view-cta',
            { disabled: !currentSwatch || !currentSticker || !previewImageDataIsReady }
          ]"
          type="button"
          :disabled="!previewImageDataIsReady"
        >{{ translations.customCheckFinish }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import baseSpinner from "@/components/Spinner";
import sceneManager from "@/mixins/Customizer/SceneManager";
import modelHelpers from "@/mixins/Customizer/ModelHelpers";
import patternMaker from "@/mixins/PatternMaker";
import undo from "@/mixins/Customizer/Undo";
import patternmakerSwatchesCarousel from "@/components/PatternMaker/MainViews/PatternMaker/SwatchesCarousel";
import patternmakerStickerTabs from "@/components/PatternMaker/MainViews/PatternMaker/StickerTabs";
import patternmakerStickersCarousel from "@/components/PatternMaker/MainViews/PatternMaker/StickersCarousel";

import geometryUpdate from '@/mixins/geometryUpdates';

export default {
  name: "patternmakerView",
  mixins:[ sceneManager, modelHelpers, patternMaker, undo, geometryUpdate ],
  components: {
    baseSpinner,
    patternmakerSwatchesCarousel,
    patternmakerStickerTabs,
    patternmakerStickersCarousel,
  },
  props: {
    isMainApp: {
      type: Boolean,
      default: false
    },
    stickersId: {
      type: Array,
      default() {
        return [];
      }
    },
    slideToSelectedItems: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.setInitialValues();
    this.$eventBus.$on('hide-pattern-maker', this.closeModalOption);
    window.addEventListener('resize', this.checkEnableCarouselNavigation);
  },
  mounted() {
    this.checkEnableCarouselNavigation();
  },
  beforeDestroy() {
    this.$eventBus.$off('hide-pattern-maker', this.closeModalOption);
    window.removeEventListener('resize', this.checkEnableCarouselNavigation);
  },
};
</script>